/**
 * Centralized API Configuration
 * This file handles all API base URL logic and provides consistent configuration across the app
 */

// API Base URL configuration with fallback logic
const getApiBaseUrl = () => {
  // If environment variable is set, use it
  
  
  // Fallback based on environment
  if (process.env.NODE_ENV === 'production') {
    return ''; // Relative URL for production
  }
  if (process.env.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL;
  }
  
  // Development fallback
  return 'http://localhost:5001';
};

// Export the configured API base URL
export const API_BASE_URL = getApiBaseUrl();
console.log("API_BASE_URL",API_BASE_URL);

// Export the full API URL (with /api suffix)
export const API_URL = `${API_BASE_URL}/api`;

// Configuration object for easy access
export const API_CONFIG = {
  baseUrl: API_BASE_URL,
  apiUrl: API_URL,
  timeout: process.env.REACT_APP_API_TIMEOUT || 10000,
  debug: process.env.REACT_APP_ENABLE_DEBUG === 'true'
};

// Helper function to get full endpoint URL
export const getApiEndpoint = (endpoint) => {
  // Remove leading slash if present to avoid double slashes
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  return `${API_URL}/${cleanEndpoint}`;
};

// Debug logging (only in development)
if (process.env.NODE_ENV === 'development' && API_CONFIG.debug) {
  console.log('API Configuration:', {
    baseUrl: API_BASE_URL,
    apiUrl: API_URL,
    environment: process.env.NODE_ENV,
    envVar: process.env.REACT_APP_API_BASE_URL
  });
} 